import './App.css';
import Weather from "./Weather";
export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />


    <footer>This <a href="https://github.com/Nasrin200/goodweather" target="_blank" className="source" rel="noreferrer">open source</a> app is made by Nasrin Alizadeh</footer>
    </div>
    </div>
  );
}
